export function generateObjectId() {
  const timestamp = Math.floor(new Date().getTime() / 1000).toString(16);
  const random = Math.random().toString(16).substring(2, 10);
  const counter = Math.floor(Math.random() * 0xffffff).toString(16);

  return (timestamp + random + counter).padEnd(24, '0');
}
